<template>
	<el-popover :placement="cfg.placement" :trigger="cfg.trigger" @after-enter="showUserCard()">
		<user-card :userId="user_id" :visible="cardVisible" :config="cfg.userCard"></user-card>
		<span slot="reference" class="text-link">{{ referenceText }}</span>
	</el-popover>
</template>

<script>
import userCard from '@/components/user-card.vue';

export default {
	components: { userCard },
	name: 'popover-user-card',
	props: {
		userId: {
			type: String,
			default: () => {
				return '';
			}
		},
		text: {
			type: String,
			default: () => {
				return '姓名';
			}
		},
		config: {
			type: Object,
			default: () => {
				return {
					placement: 'left',
					trigger: 'click',
					userCard: {
						avatarSize: 128
					}
				};
			}
		}
	},
	data() {
		return {
			cfg: {},
			user_id: null,
			cardVisible: false,
			referenceText: ''
		};
	},
	created: function() {},
	mounted() {
		this.cfg = this.config;
		this.referenceText = this.text;
		this.user_id = this.userId;
	},
	methods: {
		showUserCard() {
			this.cardVisible = true;
		}
	},
	watch: {
		userId: function(d) {
			this.user_id = d;
			this.cardVisible = false;
		},
		text: function(d) {
			this.referenceText = d;
		}
	}
};
</script>

<style>
.infoshow-list {
	display: flex;
	justify-content: space-between;
}
</style>
